import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import neTranslation from './locales/ne/translation.json';
import zhTranslation from './locales/zh/translation.json';

const savedLang = localStorage.getItem('ezpm2gui-language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ne: { translation: neTranslation },
      zh: { translation: zhTranslation },
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
